import { IcoClose } from "assets/icons";
import { useState } from "react";
import "./styles.scss";

export default function InfoBanner() {
	const [isVisible, setIsVisible] = useState(true);

	const handleClose = () => {
		setIsVisible(false);
	};

	if (!isVisible) return null;

	return (
		<div className="info-banner">
			<div className="info-banner-content">
				<span className="info-banner-text">
					CCR agora é Motiva.&nbsp;
					<a href="https://www.motiva.com.br/motiva/sobre-a-motiva/" target="_blank" rel="noopener noreferrer" className="info-banner-link">
						Saiba Mais.
					</a>
				</span>
				<button className="info-banner-close" onClick={handleClose} aria-label="Fechar banner" type="button">
					<IcoClose size="16" />
				</button>
			</div>
		</div>
	);
}
